import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/round creams/round chocolate biscuit.png";
import BiscuitImg from "../../../assets/products/round creams/Round-Chocolate.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 13,
  },
  {
    grams: 18,
  },
  {
    grams: 20,
  },
  {
    grams: 30,
  },
  {
    grams: 40,
  },
  {
    grams: 50,
  },
  {
    grams: 70,
  },
  {
    grams: 90,
  },
];

export default function ChocolateRoundProduct() {
  return (
    <>
      <Helmet>
        <title>
          Round Chocolate Cream Biscuit – BearBitz | Premium Biscuits & Cookies
        </title>
        <meta
          name="description"
          content="Explore BearBitz Round Chocolate Cream Biscuits — rich chocolate-flavored sandwich biscuits with creamy filling. View pack sizes, cartons, and global specs."
        />
        <meta
          name="keywords"
          content="Round Chocolate Cream Biscuit, BearBitz Chocolate Cream Biscuit"
        />
        <link
          rel="canonical"
          href="https://www.bearbitz.in/round-cream-biscuit/round-chocolate"
        />
        <meta
          property="og:title"
          content="Round Chocolate Cream Biscuit – BearBitz"
        />
        <meta
          property="og:description"
          content="Cream-filled chocolate sandwich biscuit in round form with premium packaging and export-ready specs."
        />
      </Helmet>

      <ProductTemplate
        productTitle="CHOCOLATE"
        productImage={BisImg}
        description="Sweet Layers of Joy.Crunchy biscuits filled with rich cream—classic favorites in every shape and flavor. A global snack sensation that delights with every bite."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#6A3E20"
        sectionBgColor="#FFC158"
        productBgcolor="#FFECCB"
        tableheadBgcolor="#6A3E20"
        tableBgcolor="#FFE7BE"
        footerBgcolor="#6A3E20"
      />
    </>
  );
}
